import cn from 'classnames';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import type { AdminInvoiceReportsListActionsProps } from './types';
import styles from './AdminInvoiceReportsListActions.module.scss';

const cx = classnames.bind(styles);

/** Toolbar shell between Search and Table — feature work fills `leading` / `trailing`. */
export const AdminInvoiceReportsListActions: FC<AdminInvoiceReportsListActionsProps> =
  memo(({ leading, trailing, containerClassName }) => {
    return (
      <div
        className={cn(cx('root'), containerClassName)}
        data-testid='admin-invoice-reports-list-actions'
      >
        <div
          className={cx('leading')}
          data-testid='admin-invoice-reports-list-actions-leading'
        >
          {leading}
        </div>
        <div
          className={cx('trailing')}
          data-testid='admin-invoice-reports-list-actions-trailing'
        >
          {trailing}
        </div>
      </div>
    );
  });

AdminInvoiceReportsListActions.displayName = 'AdminInvoiceReportsListActions';
